import { AsyncStatus } from "../lib/features/redux/base.state";

export const isIdle = (status: AsyncStatus) => status === "idle";
export const isLoading = (status: AsyncStatus) => status === "loading";
export const isSuccess = (status: AsyncStatus) => status === "success";
export const isError = (status: AsyncStatus) => status === "error";
